export default "__VITE_ASSET__D1msKO0a__"